export default __webpack_public_path__ + "static/media/CapaUser.68978931.svg";